<template>
  <div class="drugstore-groups-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h5 class="mb-0">Zarządzanie grupami aptek</h5>
      <button class="btn btn-success shadow-sm" @click="openAddModal">
        <i class="fas fa-plus-circle me-1"></i> Utwórz nową grupę
      </button>
    </div>

    <div class="windows-like-breadcrumb-card shadow-sm p-3">
      <CommonTable2
        :table="tableData"
        :key="tableData.data"
        rowIdentifier="id"
        @onItemAction="handleItemAction($event)"
        :showPaginationTop="false"
        :showPaginationBottom="false"
        :showMassActions="false"
        :showRowActions="true"
        :multiselect="false"
        :enableRowSelection="false"
      />
    </div>

    <!-- Modals -->
    <DrugstoreGroupFormModal
      v-model:showModal="showFormModal"
      :editGroup="selectedGroup"
      @onSaved="fetchGroups"
    />

    <DrugstoreGroupMembersModal
      v-model:showModal="showMembersModal"
      @update:showModal="showMembersModal = $event"
      :groupId="selectedGroup?.id"
      :groupName="selectedGroup?.name"
    />
  </div>
</template>

<script>
import { useCommonAppModule } from "@/state/pinia/commonAppModule";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import DrugstoreGroupFormModal from "./DrugstoreGroupFormModal.vue";
import DrugstoreGroupMembersModal from "./DrugstoreGroupMembersModal.vue";
import Swal from "sweetalert2";

export default {
  name: "DrugstoreGroupsList",
  components: {
    CommonTable2,
    DrugstoreGroupFormModal,
    DrugstoreGroupMembersModal
  },
  data() {
    return {
      refreshTable: true,
      showFormModal: false,
      showMembersModal: false,
      selectedGroup: null,
      tableData: {
        headers: [
          { key: "name", text: "Nazwa", type: "text", sortable: true },
          { key: "description", text: "Opis", type: "text", sortable: false },
          { key: "priority", text: "Priorytet", type: "text", sortable: true },
          { key: "actions", text: "Akcje", type: "actions", sortable: false, width: "150px" }
        ],
        data: []
      }
    };
  },
  computed: {
    commonModule() {
      return useCommonAppModule();
    }
  },
  methods: {
    fetchGroups() {
      this.refreshTable = false;
      this.commonModule.httpGetDrugstoreGroupsAll().then(() => {
          this.tableData.data = this.commonModule.getDrugstoreGroups.map(group => ({
            ...group,
            actions: [
              {
                icon: "fas fa-edit",
                class: "btn btn-info btn-sm me-1",
                text: "",
                action: "edit-group",
                enabled: true
              },
              {
                icon: "fas fa-users",
                class: "btn btn-primary btn-sm me-1",
                text: "",
                action: "manage-members",
                enabled: true
              },
              {
                icon: "fas fa-trash-alt",
                class: "btn btn-danger btn-sm",
                text: "",
                action: "delete-group",
                enabled: true
              }
            ]
          }));
          this.refreshTable = true;

      });
    },
    openAddModal() {
      this.selectedGroup = null;
      this.showFormModal = true;
    },
    handleItemAction(event) {
      const group = event.itemData;
      if (event.action.action === "edit-group") {
        this.selectedGroup = group;
        this.showFormModal = true;
      } else if (event.action.action === "manage-members") {
        this.selectedGroup = group;
        this.showMembersModal = true;
      } else if (event.action.action === "delete-group") {
        this.confirmDelete(group);
      }
    },
    confirmDelete(group) {
      Swal.fire({
        title: `Czy na pewno chcesz usunąć grupę "${group.name}"?`,
        text: "Tej operacji nie można cofnąć.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        confirmButtonText: "Tak, usuń",
        cancelButtonText: "Anuluj"
      }).then((result) => {
        if (result.isConfirmed) {
          this.commonModule.httpDeleteDrugstoreGroup({ groupId: group.id }).then(() => {
            this.fetchGroups();
          });
        }
      });
    }
  },
  mounted() {
    this.fetchGroups();
  }
};
</script>

<style scoped>
.drugstore-groups-list {
  padding: 10px;
}
</style>
